/**
 * Protobuf Convenience methods
 * Maintains old optional chaining behavior as passing undefined into protobuf-es v2 functions is undefined behavior
 */
import { clone as pbClone, equals as pbEquals, fromJson as pbFromJson, toJson as pbToJson, toJsonString as pbToJsonString, type DescMessage, type JsonReadOptions, type JsonValue, type JsonWriteOptions, type JsonWriteStringOptions, type Message, type MessageShape } from "@bufbuild/protobuf";

export * from "@bufbuild/protobuf";

// protobuf-es v2 strongly types by $typeName string, this gets around it
export function genericize(x?: Message): object {
	return x ?? {};
}

export function clone<Desc extends DescMessage>(schema: Desc, message: MessageShape<Desc>): MessageShape<Desc>;
export function clone<Desc extends DescMessage>(schema: Desc, message?: MessageShape<Desc>): MessageShape<Desc> | undefined;
export function clone<Desc extends DescMessage>(schema: Desc, message?: MessageShape<Desc>) {
	return message ? pbClone(schema, message) : undefined;
}

export function equals<Desc extends DescMessage>(schema: Desc, a?: MessageShape<Desc>, b?: MessageShape<Desc>, options?: Parameters<typeof pbEquals>[3]) {
	return a != undefined && b != undefined ? pbEquals(schema, a, b, options) : a === undefined && b === undefined;
}

export function toJson<Desc extends DescMessage, Opts extends Partial<JsonWriteOptions> | undefined = undefined>(schema: Desc, message: MessageShape<Desc>, options?: Opts): ReturnType<typeof pbToJson<Desc>>;
export function toJson<Desc extends DescMessage, Opts extends Partial<JsonWriteOptions> | undefined = undefined>(schema: Desc, message?: MessageShape<Desc>, options?: Opts): ReturnType<typeof pbToJson<Desc>> | undefined;
export function toJson<Desc extends DescMessage, Opts extends Partial<JsonWriteOptions> | undefined = undefined>(schema: Desc, message?: MessageShape<Desc>, options?: Opts) {
	return message ? pbToJson(schema, message, options) : undefined;
}

export function toJsonString<Desc extends DescMessage, Opts extends Partial<JsonWriteStringOptions> | undefined = undefined>(schema: Desc, message: MessageShape<Desc>, options?: Opts): string;
export function toJsonString<Desc extends DescMessage, Opts extends Partial<JsonWriteStringOptions> | undefined = undefined>(schema: Desc, message?: MessageShape<Desc> | null, options?: Opts): string | undefined;
export function toJsonString<Desc extends DescMessage, Opts extends Partial<JsonWriteStringOptions> | undefined = undefined>(schema: Desc, message?: MessageShape<Desc> | null, options?: Opts) {
	return message ? pbToJsonString(schema, message, options) : undefined;
}

export function fromJson<Desc extends DescMessage>(schema: Desc, json: JsonValue, options?: Partial<JsonReadOptions>): MessageShape<Desc>;
export function fromJson<Desc extends DescMessage>(schema: Desc, json?: JsonValue, options?: Partial<JsonReadOptions>): MessageShape<Desc> | undefined;
export function fromJson<Desc extends DescMessage>(schema: Desc, json?: JsonValue, options?: Partial<JsonReadOptions>) {
	return json ? pbFromJson(schema, json, options) : undefined;
}
